define((require) => {
    "use strict";

    const Marionette           = require("marionette");
    const LayerEnum            = require("ui/editor/LayerEnum");
    const WidgetCollectionView = require("ui/editor/WidgetCollectionView");
    const template             = require("ui/editor/SceneWidgetCollectionViewsLayout.tpl");

    return Marionette.Layout.extend({

        ItemView: WidgetCollectionView,

        template,

        viewScope: null,

        regions: {
            sceneWidgetContainer: ".scene-widgets-container",
            overlayWidgetContainer: ".overlay-widgets-container",
            backgroundWidgetContainer: ".background-widgets-container"
        },

        initialize({viewScope, scene}) {
            this.viewScope = viewScope;

            this.sceneWidgetCollectionView = new WidgetCollectionView({
                collection: scene.get("widgets"),
                viewScope,
                edited: true,
                container: this.sceneWidgetContainer,
                layer: LayerEnum.SCENE,
                scene
            });

            this.overlayWidgetCollectionView = new WidgetCollectionView({
                collection: viewScope.viewModel.get("experience").get("overlayScene").get("widgets"),
                viewScope,
                edited: true,
                container: this.overlayWidgetContainer,
                layer: LayerEnum.OVERLAY,
                scene
            });

            this.backgroundWidgetCollectionView = new WidgetCollectionView({
                collection: viewScope.viewModel.get("experience").get("backgroundScene").get("widgets"),
                viewScope,
                edited: true,
                container: this.backgroundWidgetContainer,
                layer: LayerEnum.BACKGROUND,
                scene
            });

            // eslint-disable-next-line no-unused-vars
            this.listenTo(viewScope.viewModel, "change:currentLayer", (model, layer) => {
                this._showHideWidgetsBasedOnLayer();
            });

            // propagate events from child views
            this.widgetCollectionViews().forEach((widgetCollectionView) => {
                this.listenTo(widgetCollectionView.transformer, {
                    "transforming": (tGroup, model, tElement) => this.trigger("transforming", tGroup, model, tElement),
                    "select_target": (tGroup, model, tElement) => this.trigger("select_target", tGroup, model, tElement),
                    "translating": (tGroup, model, tElement) => this.trigger("translating", tGroup, model, tElement),
                    "transforming_end": (tGroup, model, tElement) => this.trigger("transforming_end", tGroup, model, tElement)
                });
            });
        },

        onShow() {
            this.sceneWidgetContainer.show(this.sceneWidgetCollectionView);
            this.overlayWidgetContainer.show(this.overlayWidgetCollectionView);
            this.backgroundWidgetContainer.show(this.backgroundWidgetCollectionView);

            this._showHideWidgetsBasedOnLayer();
        },

        /**
         *
         * @param {Layer} currentLayer
         */
        _showHideWidgetsBasedOnLayer() {
            this.widgetCollectionViews().forEach((view) => {
                view.setActiveState();
            });
        },

        activeLayerWidgetCollectionView() {
            const currentLayer = this.viewScope.viewModel.get("currentLayer");

            switch (currentLayer) {
                case LayerEnum.SCENE:
                    return this.sceneWidgetCollectionView;
                case LayerEnum.OVERLAY:
                    return this.overlayWidgetCollectionView;
                case LayerEnum.BACKGROUND:
                    return this.backgroundWidgetCollectionView;
                default:
                    throw new Error(`unrecognised layer: '${currentLayer.toString()}'`);
            }
        },

        // todo - marionette?
        widgetCollectionViews() {
            return [this.sceneWidgetCollectionView, this.overlayWidgetCollectionView, this.backgroundWidgetCollectionView];
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/SceneWidgetCollectionViewsLayout.js